import * as React from "react";
import { cn } from "@/lib/utils";
import { Typography } from "@/components/app/Typography";

export interface PageHeaderProps {
  /** Page title */
  title: string;
  /** Subtitle / description below the title */
  description?: string;
  /** Actions rendered on the right side (buttons, etc.) */
  actions?: React.ReactNode;
  className?: string;
}

/**
 * PageHeader — reusable page title bar used across all dashboard pages.
 *
 * Usage:
 * <PageHeader
 *   title="Dashboard"
 *   description="Lorem ipsum dolor sit amet consectetur."
 *   actions={<AppButton startIcon={<Plus size={16} />}>Add Product</AppButton>}
 * />
 */
const PageHeader = ({ title, description, actions, className }: PageHeaderProps) => {
  return (
    <div className={cn("flex-col md:flex-row flex-wrap flex items-start justify-between gap-4 mb-6", className)}>
      <div>
        <Typography variant="h4">{title}</Typography>
        {description && (
          <Typography className="mt-0.5" color="muted">{description}</Typography>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0 w-full sm:w-auto">{actions}</div>}
    </div>
  );
};

PageHeader.displayName = "PageHeader";

export { PageHeader };
